import { render } from "./SalesCultureDataForm.vue?vue&type=template&id=2a0fe93f&scoped=true&ts=true"
import script from "./SalesCultureDataForm.vue?vue&type=script&lang=ts"
export * from "./SalesCultureDataForm.vue?vue&type=script&lang=ts"

import "./SalesCultureDataForm.vue?vue&type=style&index=0&id=2a0fe93f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0fe93f"]])

export default __exports__